var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { nanoid } from "nanoid";
class ExperienceActivationImpl {
  constructor(activation) {
    __publicField(this, "id");
    __publicField(this, "name");
    __publicField(this, "preview");
    __publicField(this, "data");
    __publicField(this, "details");
    __publicField(this, "settings");
    __publicField(this, "social");
    __publicField(this, "socialSettings");
    __publicField(this, "topBarSettings");
    __publicField(this, "version");
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    this.id = activation.id;
    this.name = activation.name;
    this.preview = {
      ...((_a = activation.settings) == null ? void 0 : _a.preview) ?? {},
      text: (_c = (_b = activation.data) == null ? void 0 : _b.meta) == null ? void 0 : _c.display,
      icon: ((_e = (_d = activation.data) == null ? void 0 : _d.meta) == null ? void 0 : _e.icon) ?? ((_i = (_h = (_g = (_f = activation.previewImage) == null ? void 0 : _f.file) == null ? void 0 : _g.formats) == null ? void 0 : _h.thumbnail) == null ? void 0 : _i.url) ?? ((_k = (_j = activation == null ? void 0 : activation.previewImage) == null ? void 0 : _j.file) == null ? void 0 : _k.url)
    };
    this.details = {
      style: (_m = (_l = activation.data) == null ? void 0 : _l.meta) == null ? void 0 : _m.style,
      contentStyle: (_o = (_n = activation.data) == null ? void 0 : _n.meta) == null ? void 0 : _o.contentStyle,
      blockStyle: (_q = (_p = activation.data) == null ? void 0 : _p.meta) == null ? void 0 : _q.blockStyle,
      template: activation.template ?? []
    };
    this.data = {
      meta: {
        phone: (_s = (_r = activation.data) == null ? void 0 : _r.meta) == null ? void 0 : _s.phone
      }
    };
    this.social = ((_u = (_t = activation.data) == null ? void 0 : _t.meta) == null ? void 0 : _u.social) ?? [];
    this.socialSettings = ((_w = (_v = activation.data) == null ? void 0 : _v.meta) == null ? void 0 : _w.socialSettings) ?? {};
    this.topBarSettings = ((_y = (_x = activation.data) == null ? void 0 : _x.meta) == null ? void 0 : _y.topBarSettings) ?? {
      backgroundStyle: {},
      closeStyle: {}
    };
    this.settings = activation.settings ?? {};
    this.version = activation.version;
  }
}
class ExperienceActivationInstanceImpl extends ExperienceActivationImpl {
  constructor(activation, instance) {
    super(activation);
    __publicField(this, "instance");
    this.instance = formatInstance(instance, activation);
  }
}
function formatInstance(instance, activation) {
  let duration = 0;
  if (instance.when != null) {
    duration = instance.when.end - instance.when.start;
  } else if (instance.repeat != null) {
    duration = instance.duration ?? 0;
  } else if (instance.static === true) {
    duration = -1;
  } else if (instance.now === true) {
    const start = "_addedAt" in activation && typeof activation._addedAt === "number" ? activation._addedAt : 0;
    duration = instance.duration ?? 0;
    const end = start + duration;
    instance.when = {
      start,
      end
    };
  } else if (instance.fill != null) {
    duration = instance.fill.duration ?? 0;
  }
  return {
    ...instance,
    id: instance.id ?? nanoid(),
    duration
  };
}
export {
  ExperienceActivationImpl,
  ExperienceActivationInstanceImpl
};
